import { render, staticRenderFns } from "./BoardViewPage.vue?vue&type=template&id=9360630e&scoped=true&"
import script from "./BoardViewPage.vue?vue&type=script&lang=js&"
export * from "./BoardViewPage.vue?vue&type=script&lang=js&"
import style0 from "./BoardViewPage.vue?vue&type=style&index=0&id=9360630e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9360630e",
  null
  
)

export default component.exports